var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilesIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 30,
    viewBox: "0 0 41 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5f00a0",
    fillRule: "nonzero",
    d: "M25.313 10.56c1.044 0 2.189.151 3.435.454 1.415.354 2.56.825 3.436 1.415 1.044.69 1.566 1.465 1.566 2.324v2.122H16.875v-2.122c0-.859.522-1.634 1.566-2.324.876-.59 2.021-1.061 3.436-1.415 1.246-.303 2.391-.454 3.435-.454zm0-2.123c-.758 0-1.457-.189-2.097-.568-.64-.379-1.15-.888-1.529-1.528S21.12 5 21.12 4.244c0-.758.19-1.465.568-2.122.38-.657.889-1.175 1.529-1.554C23.856.19 24.555 0 25.312 0c.758 0 1.457.19 2.097.568.64.38 1.15.897 1.529 1.554s.568 1.364.568 2.122c0 .758-.19 1.457-.568 2.097-.38.64-.889 1.15-1.529 1.528-.64.379-1.339.569-2.096.569z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.938)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.045,
    cy: 11.183,
    r: 1,
    stroke: "#5f00a0",
    strokeWidth: 3.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.581,
    cy: 11.183,
    r: 1,
    stroke: "#5f00a0",
    strokeWidth: 3.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.629,
    cy: 11.183,
    r: 1,
    stroke: "#5f00a0",
    strokeWidth: 3.333
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5f00a0",
    d: "M17.73 9.032h1.214c-.1.059-.201.139-.302.24-.101.102-.203.224-.305.368-.1-.144-.201-.266-.302-.368-.101-.101-.203-.181-.305-.24zM12.4.136c.02-.09.054-.136.1-.136.046 0 .08.045.1.136l.1.27V3.73c0 .13.054.253.15.34.096.088.15.212.15.341V7.73L12.812 8h-.627L12 7.729V4.43c0-.134.054-.261.15-.354.096-.093.15-.22.15-.353V.407l.1-.271z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5f00a0",
    d: "M5.157 3.898c.1-.21.244-.314.43-.314h1.146C7 1.921 8.145.87 10.173.43h1.717v8.602h2.006v.479c-.36.461-.573 1.041-.573 1.672h-7.02c0-1.505-1.218-2.724-2.722-2.724-1.503 0-2.721 1.22-2.721 2.724H0V6.992c.1-.105.258-.191.476-.26l4.681-.28V3.898zm1.129.26c-.307 0-.556.248-.556.555v1.183c0 .307.249.556.556.556h1.18c.308 0 .556-.25.556-.556V4.713c0-.307-.248-.555-.555-.555H6.286z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5f00a0",
    fillRule: "nonzero",
    d: "M29.312 22.638c0-.263.078-.483.234-.659.157-.176.392-.264.705-.264.313 0 .55.088.713.264.162.176.243.396.243.66 0 .252-.081.463-.243.634-.162.17-.4.255-.713.255-.313 0-.548-.085-.705-.255-.156-.17-.234-.382-.234-.635zm4.559 0c0-.263.078-.483.235-.659.156-.176.391-.264.704-.264.313 0 .55.088.713.264.162.176.243.396.243.66 0 .252-.081.463-.243.634-.162.17-.4.255-.713.255-.313 0-.548-.085-.704-.255-.157-.17-.235-.382-.235-.635zm4.56 0c0-.263.077-.483.234-.659.157-.176.391-.264.705-.264.313 0 .55.088.712.264.162.176.243.396.243.66 0 .252-.08.463-.243.634-.162.17-.4.255-.712.255-.314 0-.548-.085-.705-.255-.157-.17-.235-.382-.235-.635z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilesIconGreen);
export default __webpack_public_path__ + "static/media/profiles_icon_green.c02f1df063331ae95e446c8ff32de7b8.svg";
export { ForwardRef as ReactComponent };